/* Real-time 3D E340: procedural model (no eufy logo), studio light, drag + inertia, press to ring, AR export. */
const C1 = window.C1;
const stage = C1 && C1.$("stage3d");
const H = 0.170, W = H / 2.95, ZF = 0.018, ZB = -0.018, ZS = -0.003, BEV = 0.0012;
const VC = -0.0685, UC = 0.0005;                 /* chamfer: front face ends at VC, bottom starts at UC */
const ZG = ZF + 0.0012;                          /* front of the glass */
let T = null;                                    /* { THREE, RoomEnvironment, RoundedBoxGeometry } */
let loading = null;
function hasWebGL(){ try { const c = document.createElement("canvas"); return !!(c.getContext("webgl2") || c.getContext("webgl")); } catch (e) { return false; } }
function loadThree(){
  if (!loading) loading = Promise.all([
    import("https://cdn.jsdelivr.net/npm/three@0.170.0/+esm"),
    import("https://cdn.jsdelivr.net/npm/three@0.170.0/examples/jsm/environments/RoomEnvironment.js/+esm"),
    import("https://cdn.jsdelivr.net/npm/three@0.170.0/examples/jsm/geometries/RoundedBoxGeometry.js/+esm")
  ]).then(([THREE, re, rb]) => (T = { THREE, RoomEnvironment: re.RoomEnvironment, RoundedBoxGeometry: rb.RoundedBoxGeometry }));
  return loading;
}
function lathe(THREE, pts, seg = 64){
  const g = new THREE.LatheGeometry(pts.map(p => new THREE.Vector2(p[0], p[1])), seg);
  g.rotateX(Math.PI / 2);                        /* lathe axis Y -> facing +Z */
  return g;
}
function roundRect(THREE, w, h, r){
  const s = new THREE.Shape(), x = -w / 2, y = -h / 2;
  s.moveTo(x + r, y); s.lineTo(x + w - r, y); s.quadraticCurveTo(x + w, y, x + w, y + r);
  s.lineTo(x + w, y + h - r); s.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
  s.lineTo(x + r, y + h); s.quadraticCurveTo(x, y + h, x, y + h - r);
  s.lineTo(x, y + r); s.quadraticCurveTo(x, y, x + r, y);
  return s;
}
function plate(THREE, w, h, r, d, bev){
  const g = new THREE.ExtrudeGeometry(roundRect(THREE, w, h, r), { depth: d, bevelEnabled: true, bevelThickness: bev, bevelSize: bev, bevelSegments: 2, curveSegments: 6 });
  return g;
}
function buildE340(){
  const { THREE, RoundedBoxGeometry } = T;
  const M = {
    frame: new THREE.MeshPhysicalMaterial({ color: 0x303338, metalness: 0.45, roughness: 0.38, clearcoat: 0.35, clearcoatRoughness: 0.35 }),
    back: new THREE.MeshStandardMaterial({ color: 0x2a2c30, metalness: 0.15, roughness: 0.82 }),
    glass: new THREE.MeshPhysicalMaterial({ color: 0x030405, metalness: 0, roughness: 0.06, clearcoat: 1, clearcoatRoughness: 0.03 }),
    win: new THREE.MeshPhysicalMaterial({ color: 0x0e1014, metalness: 0, roughness: 0.34, clearcoat: 0.5, clearcoatRoughness: 0.25 }),
    housing: new THREE.MeshPhysicalMaterial({ color: 0x0b0c0e, metalness: 0.2, roughness: 0.42, clearcoat: 0.4, clearcoatRoughness: 0.3, side: THREE.DoubleSide }),
    groove: new THREE.MeshStandardMaterial({ color: 0x17181b, metalness: 0.85, roughness: 0.26, side: THREE.DoubleSide }),
    lens: new THREE.MeshPhysicalMaterial({ color: 0x05060a, metalness: 0.1, roughness: 0.02, clearcoat: 1, clearcoatRoughness: 0, side: THREE.DoubleSide }),
    pupil: new THREE.MeshStandardMaterial({ color: 0x0a1330, emissive: 0x1b3fa0, emissiveIntensity: 0.9, roughness: 0.1 }),
    dot: new THREE.MeshStandardMaterial({ color: 0x202226, roughness: 0.5 }),
    ring: new THREE.MeshStandardMaterial({ color: 0x0b1a33, emissive: 0x1f5cff, emissiveIntensity: 1.6, roughness: 0.35, side: THREE.DoubleSide }),
    face: new THREE.MeshPhysicalMaterial({ color: 0x07080a, metalness: 0, roughness: 0.16, clearcoat: 1, clearcoatRoughness: 0.12, side: THREE.DoubleSide }),
    silver: new THREE.MeshStandardMaterial({ color: 0xc8ccd2, metalness: 1, roughness: 0.22, side: THREE.DoubleSide }),
    light: new THREE.MeshStandardMaterial({ color: 0x9aa0a8, metalness: 0.9, roughness: 0.34, side: THREE.DoubleSide }),
    slot: new THREE.MeshStandardMaterial({ color: 0x060607, roughness: 0.9 })
  };
  const g = new THREE.Group(); g.name = "E340";
  const add = (geo, mat, x = 0, y = 0, z = 0, parent = g) => { const m = new THREE.Mesh(geo, mat); m.position.set(x, y, z); parent.add(m); return m; };
  /* front shell: side profile (u = depth, v = height) extruded across the width, chamfered bottom-front */
  const r = 0.002, umax = ZF - BEV, vmax = H / 2 - BEV, vmin = -H / 2 + BEV;
  const s = new THREE.Shape();
  s.moveTo(ZS, vmin); s.lineTo(UC, vmin); s.lineTo(umax, VC); s.lineTo(umax, vmax - r);
  s.quadraticCurveTo(umax, vmax, umax - r, vmax); s.lineTo(ZS, vmax); s.lineTo(ZS, vmin);
  const shellGeo = new THREE.ExtrudeGeometry(s, { depth: W - 2 * BEV, bevelEnabled: true, bevelThickness: BEV, bevelSize: BEV, bevelSegments: 3, curveSegments: 5 });
  shellGeo.rotateY(-Math.PI / 2); shellGeo.translate((W - 2 * BEV) / 2, 0, 0);
  add(shellGeo, M.frame);
  /* back shell, bosses, battery latch recess */
  add(new RoundedBoxGeometry(W - 0.0014, H - 0.003, 0.016, 3, 0.0024), M.back, 0, 0, -0.0105);
  add(new RoundedBoxGeometry(0.017, 0.012, 0.004, 2, 0.0015), M.back, 0, 0.053, ZB - 0.0012);
  add(new RoundedBoxGeometry(0.017, 0.012, 0.004, 2, 0.0015), M.back, 0, -0.055, ZB - 0.0012);
  add(new THREE.BoxGeometry(0.028, 0.026, 0.0006), M.slot, 0, 0.022, ZB - 0.0006);
  /* front glass + top light window + sensor dots */
  const gTop = 0.0794, gBot = -0.0665, gW = 0.0455;
  add(plate(THREE, gW, gTop - gBot, 0.0022, 0.0006, 0.0003), M.glass, 0, (gTop + gBot) / 2, ZF + 0.0003);
  add(plate(THREE, gW - 0.0036, 0.0152, 0.0012, 0.00005, 0.00002), M.win, 0, 0.0716, ZG - 0.00002);
  add(new THREE.CircleGeometry(0.0007, 24), M.dot, 0, 0.0198, ZG + 0.00004);
  add(new THREE.CircleGeometry(0.0007, 24), M.dot, 0, 0.0123, ZG + 0.00004);
  /* main camera: housing cone, fine concentric grooves, lens dome, blue pupil */
  const cam = new THREE.Group(); cam.position.set(0, 0.0412, ZG); g.add(cam);
  add(lathe(THREE, [[0.0182, 0], [0.0178, 0.0006], [0.0168, 0.0012], [0.014, 0.0016], [0.0115, 0.0017]]), M.housing, 0, 0, 0, cam);
  const gr = [[0.0115, 0.0008]];
  for (let i = 0; i < 7; i++) { const a = 0.0113 - i * 0.00068; gr.push([a, 0.0008], [a - 0.00017, 0.00125], [a - 0.00051, 0.00125], [a - 0.00068, 0.0008]); }
  gr.push([0.0065, 0.0006]);
  add(lathe(THREE, gr), M.groove, 0, 0, 0, cam);
  add(lathe(THREE, [[0.0065, 0.0008], [0.006, 0.0014], [0.0048, 0.0019], [0.003, 0.0022], [0.0001, 0.0023]]), M.lens, 0, 0, 0, cam);
  add(new THREE.CircleGeometry(0.0016, 32), M.pupil, 0, 0, 0.00232, cam);
  /* button: LED ring + domed face (the face is what moves when pressed) */
  const btn = new THREE.Group(); btn.position.set(0, -0.0391, ZG); g.add(btn);
  const ringMesh = add(lathe(THREE, [[0.01815, 0], [0.0181, 0.00035], [0.0168, 0.00035], [0.01675, 0]]), M.ring, 0, 0, 0, btn);
  const face = add(lathe(THREE, [[0.0165, 0], [0.0164, 0.0004], [0.015, 0.00075], [0.01, 0.00095], [0.0001, 0.001]]), M.face, 0, 0, 0, btn);
  /* chamfer window at the bottom: downward camera + two lights */
  const n = new THREE.Vector2(0.0165, -0.0175).normalize();          /* (z, y) outward normal of the chamfer */
  const mz = (umax + UC) / 2 + n.x * BEV, my = (VC + vmin) / 2 + n.y * BEV;
  const chin = new THREE.Group(); chin.position.set(0, my, mz); chin.rotation.x = Math.asin(-n.y); g.add(chin);
  add(plate(THREE, 0.0468, 0.016, 0.0026, 0.0002, 0.0001), M.glass, 0, 0, 0, chin);
  add(lathe(THREE, [[0.0066, 0.0003], [0.0064, 0.0009], [0.005, 0.001], [0.0048, 0.0006]]), M.silver, 0, 0, 0, chin);
  add(lathe(THREE, [[0.0047, 0.0005], [0.0038, 0.0011], [0.002, 0.0014], [0.0001, 0.0015]]), M.lens, 0, 0, 0, chin);
  add(new THREE.CircleGeometry(0.0013, 28), M.pupil, 0, 0, 0.00153, chin);
  for (const x of [-0.0158, 0.0158]) add(lathe(THREE, [[0.003, 0.0003], [0.0029, 0.0007], [0.0018, 0.001], [0.0001, 0.0011]], 40), M.light, x, 0, 0, chin);
  /* top sensor strip and the speaker slots underneath */
  add(new THREE.BoxGeometry(0.044, 0.0003, 0.0035), M.win, 0, H / 2 + 0.00012, ZF - 0.0028);
  for (let i = 0; i < 6; i++) add(new THREE.BoxGeometry(0.0012, 0.0003, 0.0034), M.slot, (i - 2.5) * 0.0028, -(H - 0.003) / 2 - 0.00012, -0.0078);
  const proxy = add(new THREE.CircleGeometry(0.0186, 40), new THREE.MeshBasicMaterial(), 0, 0, 0.0013, btn);
  proxy.visible = false;                                              /* tap target: whole button + ring, never drawn or exported */
  return { group: g, face, ringMesh, ringMat: M.ring, pick: [proxy] };
}
/* ---------- renderer, framing, loop ---------- */
let R = null;
const REST_YAW = 0.5, REST_PITCH = -0.1, reduce = C1.reduce;
const COARSE = !!(window.matchMedia && matchMedia("(pointer: coarse)").matches);
let lastScroll = -1e9, scrollEndT = 0, stageNear = false, wanted = false;
const waiters = [];
function wake(){ waiters.splice(0).forEach(f => f()); }   /* a waiter that re-queues itself waits for the next wake */
const scrolling = () => performance.now() - lastScroll < 160;
if (stage) {
  C1.onScroll(() => { lastScroll = performance.now(); clearTimeout(scrollEndT); scrollEndT = setTimeout(() => { wake(); kick(); }, 220); });
  new IntersectionObserver(es => { stageNear = es[es.length - 1].isIntersecting; if (stageNear) wake(); }, { rootMargin: "300px 0px" }).observe(stage);
  document.addEventListener("visibilitychange", wake);
}
/* resolves once the stage is near, the page has been still for 600 ms and the browser is idle (at once after a tap) */
function quiet(){
  return new Promise(res => {
    const go = () => {
      if (!wanted && (!stageNear || document.hidden)) { waiters.push(go); return; }
      const still = performance.now() - lastScroll;
      if (!wanted && still < 600) { setTimeout(go, 620 - still); return; }
      if (!wanted && "requestIdleCallback" in window) requestIdleCallback(() => res(), { timeout: 600 }); else setTimeout(res, 16);
    };
    go();
  });
}
const shadowEl = C1.$("shadow3d");
function haloTex(THREE){
  const c = document.createElement("canvas"); c.width = c.height = 128;
  const x = c.getContext("2d"), g = x.createRadialGradient(64, 64, 0, 64, 64, 64);
  g.addColorStop(0, "rgba(40,120,255,0)"); g.addColorStop(0.5, "rgba(40,120,255,0)");
  g.addColorStop(0.585, "rgba(90,165,255,.9)"); g.addColorStop(0.7, "rgba(40,120,255,.22)"); g.addColorStop(1, "rgba(40,120,255,0)");
  x.fillStyle = g; x.fillRect(0, 0, 128, 128);
  const t = new THREE.CanvasTexture(c); t.colorSpace = THREE.SRGBColorSpace; return t;
}
function frame(){
  const { THREE } = T, w = stage.clientWidth, h = stage.clientHeight;
  if (!w || !h) return;
  R.renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, COARSE ? 1.5 : 2) * R.q);
  R.renderer.setSize(w, h, false);
  const cs = getComputedStyle(stage), mt = parseFloat(cs.getPropertyValue("--mt")) || 0.07, mh = parseFloat(cs.getPropertyValue("--mh")) || 0.76;
  /* place the camera so the front face lands exactly on the poster's box: no jump at the swap */
  const k = (H / 2) / mh, tn = Math.tan(THREE.MathUtils.degToRad(R.camera.fov / 2)), cy = H / 2 - (1 - 2 * mt) * k;
  R.camera.aspect = w / h; R.camera.position.set(0, cy, ZG + k / tn); R.camera.lookAt(0, cy, 0); R.camera.updateProjectionMatrix();
}
function wrap(a){ return Math.atan2(Math.sin(a), Math.cos(a)); }
function tick(now){
  R.raf = 0;
  if (scrolling() && !R.drag && R.press < 0 && Math.abs(R.vel) <= 0.02) { R.last = 0; return; }   /* resumes when the scroll stops */
  const dt = Math.min(0.05, (now - (R.last || now)) / 1000); R.last = now;
  const t = (now - R.t0) / 1000;
  const amp = reduce ? 0 : Math.max(0, Math.min(1, (R.swayUntil - now) / 2000));   /* the idle sway fades out, then the loop stops */
  if (!R.drag) {
    if (Math.abs(R.vel) > 0.02) { R.yaw += R.vel * dt; R.vel *= Math.exp(-dt * 3.2); }
    else if (!reduce && now > R.idleAt) {
      const k = 1 - Math.exp(-dt * 1.5);
      R.yaw += wrap(REST_YAW + Math.sin(t * 0.45) * 0.22 * amp - R.yaw) * k;
      R.pitch += (REST_PITCH + Math.sin(t * 0.33) * 0.04 * amp - R.pitch) * k;
    }
  }
  const fl = reduce ? 0 : Math.sin(t * 1.1) * 0.0022 * amp;
  R.pivot.rotation.set(R.pitch, R.yaw, 0); R.pivot.position.y = fl;
  shadowEl.style.transform = "translate(-50%,-50%) scale(" + (1 - fl * 45).toFixed(3) + ")";
  shadowEl.style.opacity = (0.9 - fl * 70).toFixed(3);
  let busy = R.drag || Math.abs(R.vel) > 0.02;
  if (R.press >= 0) {
    const p = (now - R.press) / 1000;
    const down = p < 0.07 ? p / 0.07 : p < 0.2 ? 1 : p < 0.42 ? 1 - (p - 0.2) / 0.22 : 0;
    const env = p < 1.6 ? Math.pow(Math.sin(p / 0.8 * Math.PI), 2) * (1 - p / 2.2) : 0;
    R.model.face.position.z = -0.0007 * down;
    R.model.ringMat.emissiveIntensity = 1.6 + 3.2 * env;
    R.halo.material.opacity = 0.35 + 0.65 * env;
    if (p > 1.65) { R.press = -1; R.model.face.position.z = 0; R.model.ringMat.emissiveIntensity = 1.6; R.halo.material.opacity = 0.35; }
    busy = true;
  }
  const pose = R.yaw.toFixed(4) + "," + R.pitch.toFixed(4) + "," + fl.toFixed(5) + (busy ? "," + now : "");
  if (pose !== R.pose) { R.renderer.render(R.scene, R.camera); R.pose = pose; }   /* nothing moved: keep the last frame */
  if (R.frames < 60 && dt > 0) { R.frames++; R.slow += dt; if (R.frames === 60 && R.slow / 60 > 0.022 && R.q > 0.8) { R.q = 0.75; frame(); R.pose = ""; } }
  const settling = !reduce && (amp > 0 || now < R.idleAt || Math.abs(wrap(REST_YAW - R.yaw)) > 0.0015 || Math.abs(REST_PITCH - R.pitch) > 0.0015);
  if (R.visible && !document.hidden && (busy || settling)) R.raf = requestAnimationFrame(tick);
}
function kick(){ if (R && !R.raf && R.visible && !document.hidden) R.raf = requestAnimationFrame(tick); }
let starting = null;
function start3D(){ return starting || (starting = boot3D()); }
async function boot3D(){
  if (!hasWebGL()) throw new Error("no webgl");
  await loadThree();
  await quiet();
  const { THREE, RoomEnvironment } = T;
  const canvas = document.createElement("canvas");
  canvas.setAttribute("aria-hidden", "true");
  const renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true });
  renderer.setClearColor(0x000000, 0);
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.05;
  const scene = new THREE.Scene();
  await quiet();
  const pmrem = new THREE.PMREMGenerator(renderer);
  scene.environment = pmrem.fromScene(new RoomEnvironment(), 0.04).texture; pmrem.dispose();
  const key = new THREE.DirectionalLight(0xffffff, 1.3); key.position.set(-0.5, 0.7, 0.9); scene.add(key);
  const rim = new THREE.DirectionalLight(0xcfe3ff, 1.0); rim.position.set(0.7, 0.3, -0.8); scene.add(rim);
  await quiet();
  const model = buildE340(), pivot = new THREE.Group();
  pivot.add(model.group); scene.add(pivot);
  const halo = new THREE.Mesh(new THREE.PlaneGeometry(0.06, 0.06), new THREE.MeshBasicMaterial({ map: haloTex(THREE), transparent: true,
    blending: THREE.AdditiveBlending, depthWrite: false, toneMapped: false, opacity: 0.35 }));
  halo.position.set(0, -0.0391, ZG + 0.0013); pivot.add(halo);          /* render-only: never exported */
  const camera = new THREE.PerspectiveCamera(22, 1, 0.05, 10);
  await quiet();
  /* queue every shader now and let the GPU compile them while the page idles, so the first frame doesn't wait */
  if (renderer.extensions.has("KHR_parallel_shader_compile")) { try { await renderer.compileAsync(scene, camera); } catch (e) {} }
  else { renderer.compile(scene, camera); renderer.getContext().flush(); await new Promise(r => setTimeout(r, 300)); }
  await quiet();
  R = { renderer, scene, camera, pivot, model, halo, canvas, q: 1, yaw: 0, pitch: 0, vel: 0, drag: null, press: -1,
        idleAt: performance.now() + 900, t0: performance.now(), visible: true, raf: 0, frames: 0, slow: 0, last: 0,
        swayUntil: performance.now() + 9000, pose: "" };
  stage.appendChild(canvas);
  frame();
  renderer.render(scene, camera);
  stage.classList.add("live");
  wire(THREE);
  kick();
  return R;
}
function wire(THREE){
  const { canvas, camera, scene, model } = R, ray = new THREE.Raycaster(), ndc = new THREE.Vector2();
  function hit(x, y){
    const b = canvas.getBoundingClientRect();
    ndc.set(((x - b.left) / b.width) * 2 - 1, -((y - b.top) / b.height) * 2 + 1);
    scene.updateMatrixWorld(); ray.setFromCamera(ndc, camera);
    return ray.intersectObjects(model.pick, false).length > 0;
  }
  let hq = 0;
  function hover(e){ if (hq) return; const x = e.clientX, y = e.clientY; hq = requestAnimationFrame(() => { hq = 0; stage.classList.toggle("hot", hit(x, y)); }); }
  canvas.addEventListener("pointerdown", e => {
    if (e.pointerType === "mouse" && e.button !== 0) return;
    const now = performance.now();
    R.drag = { id: e.pointerId, x: e.clientX, y: e.clientY, t: now, lt: now, moved: 0 };
    R.vel = 0; stage.classList.add("touched");
    try { canvas.setPointerCapture(e.pointerId); } catch (_) {}
    kick();
  });
  canvas.addEventListener("pointermove", e => {
    const d = R.drag;
    if (!d || d.id !== e.pointerId) { if (e.pointerType === "mouse") hover(e); return; }
    const now = performance.now(), dx = e.clientX - d.x, dy = e.clientY - d.y;
    d.x = e.clientX; d.y = e.clientY; d.moved += Math.abs(dx) + Math.abs(dy);
    const dyaw = dx * 0.0115; R.yaw += dyaw;
    if (e.pointerType === "mouse") R.pitch = Math.max(-0.5, Math.min(0.4, R.pitch + dy * 0.006));
    const s = Math.max(8, now - d.lt) / 1000; d.lt = now;
    R.vel = R.vel * 0.6 + (dyaw / s) * 0.4;
    R.idleAt = now + 2600; kick();
  });
  function end(e, cancelled){
    const d = R.drag; if (!d || d.id !== e.pointerId) return;
    R.drag = null;
    const now = performance.now();
    if (now - d.lt > 90) R.vel = 0;
    R.idleAt = now + 2600; R.swayUntil = now + 7600;
    if (!cancelled && d.moved < 8 && now - d.t < 500 && hit(e.clientX, e.clientY)) { C1.ring(true); press(); }
    kick();
  }
  canvas.addEventListener("pointerup", e => end(e, false));
  canvas.addEventListener("pointercancel", e => end(e, true));
  canvas.addEventListener("pointerleave", () => stage.classList.remove("hot"));
  C1.three.hit = hit;
  new IntersectionObserver(es => { R.visible = es[es.length - 1].isIntersecting; if (R.visible) { R.last = 0; R.swayUntil = Math.max(R.swayUntil, performance.now() + 5000); kick(); } }).observe(stage);
  document.addEventListener("visibilitychange", () => { if (!document.hidden) { R.last = 0; kick(); } });
  if ("ResizeObserver" in window) new ResizeObserver(() => { frame(); R.renderer.render(R.scene, R.camera); R.pose = ""; kick(); }).observe(stage);
}
function press(){ if (!R) return; R.press = performance.now(); R.swayUntil = Math.max(R.swayUntil, R.press + 6000); kick(); }
C1.three = {
  press,
  nudge(d){ if (!R) return; R.yaw += d; R.vel = 0; R.idleAt = performance.now() + 2600; R.swayUntil = R.idleAt + 5000; stage.classList.add("touched"); kick(); },
  buttonScreen(){                                   /* for automated checks: where the round button is on screen */
    if (!R) return null;
    const v = new T.THREE.Vector3(0, -0.0391, ZG + 0.001); R.scene.updateMatrixWorld(); R.model.group.localToWorld(v); v.project(R.camera);
    const b = R.canvas.getBoundingClientRect();
    return { x: b.left + (v.x + 1) / 2 * b.width, y: b.top + (1 - v.y) / 2 * b.height };
  },
  ready: () => !!R,
  pose(y, p){ if (!R) return; R.yaw = y; R.pitch = p; R.vel = 0; R.idleAt = Infinity; R.pose = ""; kick(); }
};
/* ---------- boot: poster first, three.js only when the stage is near and the page is idle ---------- */
(function boot(){
  if (!stage || !hasWebGL()) return;
  const afterLoad = fn => { if (document.readyState === "complete") fn(); else addEventListener("load", fn, { once: true }); };
  const idle = fn => ("requestIdleCallback" in window) ? requestIdleCallback(fn, { timeout: 1500 }) : setTimeout(fn, 200);
  const near = new IntersectionObserver(es => {
    if (!es.some(e => e.isIntersecting)) return;
    near.disconnect();
    /* phones: warm the download only, and build the 3D on the first touch (measured: the build froze scrolling for 1-2 s
       on a test phone). Larger screens build it once the page is still. */
    if (COARSE) afterLoad(() => idle(() => ["https://cdn.jsdelivr.net/npm/three@0.170.0/+esm", "https://cdn.jsdelivr.net/npm/three@0.170.0/examples/jsm/environments/RoomEnvironment.js/+esm",
      "https://cdn.jsdelivr.net/npm/three@0.170.0/examples/jsm/geometries/RoundedBoxGeometry.js/+esm"].forEach(u => fetch(u, { mode: "cors" }).catch(() => {}))));
    else afterLoad(() => idle(() => start3D().catch(() => {})));
  }, { rootMargin: "600px 0px" });
  near.observe(stage);
  if (COARSE) stage.classList.add("tap3d");
  stage.addEventListener("click", () => { wanted = true; wake(); start3D().catch(() => {}); }, { once: true });   /* a tap, never a scroll that starts on the stage */
})();
